import { ChatIcon, Typography } from "@codat/orchard-ui";
import React from "react";

import styles from "./PromptSuggestion.module.scss";

interface PromptSuggestionProps {
  text: string;
  onClick: (text: string) => void;
}

const PromptSuggestion = ({ text, onClick }: PromptSuggestionProps) => (
  <button
    className={styles.promptSuggestion}
    onClick={() => onClick(text)}
    data-testid="prompt-suggestion"
  >
    <ChatIcon />
    <Typography as="span" variant="body_sm" noMargin>
      {text}
    </Typography>
  </button>
);

export default PromptSuggestion;
